export default {
  estaCarregando: false,
  objEstado: {},
  lista: []
}
